import RegisterComponent from "../components/User/RegisterComponent"

export default function AffiliateRegister() {

    return (

        <div>
            <br/>  <br/>

            <RegisterComponent
                redirect={"affiliate"}
                account_type={"affiliate"}

            />
        </div>
    )
}